import React from 'react';
import Layout from '../../components/Layout';
import User from '../../domain/User';
import UserHeader from '../../components/header/User';
import PurchasesContent from '../../components/content/Purchases';
import Sponsor from '../../components/Sponsor';
import { t, props } from 'tcomb-react';


@props({
  locale: t.Obj,
  purchases: t.Obj,
  user: User,
  goPurchase: t.Func,
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func
})
export default class Purchases extends React.Component {

  getHeader() {
    return (
      <UserHeader user={this.props.user}
        locale={this.props.locale}
        goAccount={this.props.goAccount}
        goChangePassword={this.props.goChangePassword}
        goPurchases={this.props.goPurchases}
        doLogout={this.props.doLogout} />
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }

  render() {
    const { locale } = this.props;
    return (
      <Layout header={this.getHeader()} sponsor={this.getSponsor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <PurchasesContent
          locale={locale}
          purchases={this.props.purchases}
          user={this.props.user}
          goPurchase={this.props.goPurchase}
          goAccount={this.props.goAccount}
          goChangePassword={this.props.goChangePassword}
          goPurchases={this.props.goPurchases}
          doLogout={this.props.doLogout}
          doAcceptCookies={this.props.doAcceptCookies} />
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/Purchases.js
 **/